// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  var Spinner = require('react-spinkit');

  class AddCourt extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        court_details: {
            court_name:'',
            venue_id:props.match.params.id,
            game: '',
            size:0,
            field_type:0,
            level:0,
            surface_type:0,
            price:0,
            reference_courts:[]
        },
        venue_arr:[], 
        game_arr: [],
        size_arr: [],
        field_arr: [],
        courts_arr: [],
        surface_arr: [],
        level_arr: [],
        ref_courts: [],
        temp_list_courts: [],
        temp_courts: [],
        success:false,
        message:'',
        loading: false
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.onSelect = this.onSelect.bind(this);
      this.onChange = this.onChange.bind(this);
      this.handleVenueChange = this.handleVenueChange.bind(this)
    }
  
    componentDidMount() {
        this.getDetails();
    }  

    getDetails(){
      this.setState({loading: true})
    const url = `${getLocationOrigin()}/court/get_details_for_court_creation`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            if(data.success){
              this.setState({success:data.success,message:data.message,venue_arr:data.result},()=>{this.setData(data.result)})
            }
            else{
              this.setState({success:data.success,message:data.message})
            }
           // alert("fix");
       })
       .catch(error => error)
       .finally(()=> {
        this.setState({loading:false})
       })
    }

    setData(data) {
      console.log('data',data[0].game_list)
      var new_value =  Object.assign({}, this.state.court_details);
      if(this.state.court_details.venue_id){
        let venue = data.find(each=> each.id == this.state.court_details.venue_id)
        console.log('filtered venue',venue)
        new_value['game'] = venue.game_list[0].pk
        this.setState({court_details:new_value, game_arr: venue.game_list, courts_arr: venue.ref_courts, size_arr: venue.sizes, field_arr: venue.field_types, surface_arr: venue.surface_types, level_arr: venue.levels})
      }
      else{
        new_value['venue_id'] = this.state.court_details.venue_id
        new_value['game'] = data[0].game_list[0].pk
        this.setState({court_details:new_value, game_arr: data[0].game_list, courts_arr: data[0].ref_courts, size_arr: data[0].sizes, field_arr: data[0].field_types, surface_arr: data[0].surface_types, level_arr: data[0].levels})
      }
    }

    postUpdateBooking(details,props) {
        console.log(details)
        const url = `${getLocationOrigin()}/court/add_court/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                          'court_details': details
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(response=>{  
            console.log('response',response)
            alert(response.message)
            props.history.goBack();
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }

    handleVenueChange(event){
      const name = event.target.name
      const value = event.target.value
      const data = this.state.venue_arr.find(each=> each.id == value)
      var new_value =  Object.assign({}, this.state.court_details);
      new_value[name] = value
      new_value['game'] = data.game_list[0].pk
      this.setState({game_arr:data.game_list, court_details:new_value})
    }

    handleChange(event) {
        const name = event.target.name;
        const target = event.target
        const value = target.value
        console.log(name,value)
        var new_value =  Object.assign({}, this.state.court_details);
        new_value[name] = value
        this.setState({court_details: new_value});
        // this.getAmount(this.state.equipment_details)
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        this.postUpdateBooking(this.state.court_details ,this.props)
      }

    onSelect(optionsList, selectedItem) {
        var name = optionsList.name ;
        if(name === 'court'){
            this.state.temp_list_courts.push(optionsList.id)
            this.state.temp_courts.push(optionsList)
            var new_value =  Object.assign({}, this.state.court_details);
            new_value['reference_courts'] = this.state.temp_list_game
            this.setState({ court_details: new_value, ref_courts: this.state.temp_courts});
        }
    }

    onChange(dataItem,event){
      var name = event.dataItem.name
      if(name === 'court'){
        var new_value =  Object.assign({}, this.state.court_details);
        new_value['reference_courts'] = dataItem.map(x => x.id)
        this.setState({court_details:new_value,ref_courts:dataItem.map(x =>x)});
      }
    }
  
    render() {
        console.log('amount')
        console.log(this.state.court_details);
        console.log(this.state.game_arr)

      return(
     
        <div> 
          <div>
            <button style={{borderColor:'#115691',borderRadius:'50%',color:'#115691',background:'none'}} onClick={() => history.back()}><i className="fa fa-arrow-left" aria-hidden="true"></i></button>
          </div>
          <div style={styles.container}> 
            {this.state.loading ? 
              <div className="loading-overlay" style={{display:'flex',background:'none',top:0}}>
                <Spinner name="line-scale-pulse-out" color="#115691" fadeIn='quarter'/>
              </div>
            :
              <div className="row col-md-9 table-bordered" style={styles.table}>
                <div style={styles.main_header} className="col-md-12 label_blue_1">
                   Add Court
                </div>
                <form  className="validated-form form-horizontal">
                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Court Name
                    </div>
                    <input style={styles.input} name="court_name"
                    onChange={this.handleChange} />
                  </div>
                  <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Venue
                  </div>
                  <select name="venue_id" className="col-md-6" style={styles.item_body} value={this.state.court_details.venue_id}
                    onChange={this.handleVenueChange} disabled='disabled'>
                    {
                      this.state.venue_arr.map((venue,index)=>(
                        <option key={venue.id} value={venue.id}>{venue.name}</option>
                      ))
                    }
                  </select>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Game
                  </div>
                  <select name="game" className="col-md-6" style={styles.item_body} value={this.state.court_details.game}
                    onChange={this.handleChange}>
                    {
                      this.state.game_arr.map((game,index)=>(
                        <option key={game.pk} value={game.pk}>{game.name}</option>
                      ))
                     }
                  </select>
                </div>

                {
                  this.state.court_details.game == 24 ?
                    <div>
                     
                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Temperature Controlled
                        </div>
                        <select name="temperature_controlled" className="col-md-6" style={styles.item_body} value={this.state.court_details.temperature_controlled}
                          onChange={this.handleChange}>
                            <option key={1} value={false} default>No</option>
                            <option key={2} value={true}>Yes</option>
                        </select>
                      </div>

                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Pool Length
                        </div>
                        <input style={styles.input} name="pool_length" onChange={this.handleChange} />
                      </div>

                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Pool Breadth
                        </div>
                        <input style={styles.input} name="pool_breadth" onChange={this.handleChange} />
                      </div>

                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Pool Depth
                        </div>
                        <input style={styles.input} name="pool_depth" onChange={this.handleChange} />
                      </div>

                    </div>

                  :

                    <div>

                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Size
                        </div>
                       <select name="size" className="col-md-6" style={styles.item_body} value={this.state.court_details.size}
                         onChange={this.handleChange}>
                          { 
                             Object.keys(this.state.size_arr).map((key,index)=>(
                               <option key={key} value={key}>{this.state.size_arr[key]}</option>
                              ))
                          }
                       </select>
                      </div>

                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Field Type
                        </div>
                       <select name="field_type" className="col-md-6" style={styles.item_body} value={this.state.court_details.field_type}
                         onChange={this.handleChange}>
                          { 
                             Object.keys(this.state.field_arr).map((key,index)=>(
                               <option key={key} value={key}>{this.state.field_arr[key]}</option>
                              ))
                          }
                       </select>
                      </div>

                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Surface Type
                        </div>
                       <select name="surface_type" className="col-md-6" style={styles.item_body} value={this.state.court_details.surface_type}
                         onChange={this.handleChange}>
                          { 
                             Object.keys(this.state.surface_arr).map((key,index)=>(
                               <option key={key} value={key}>{this.state.surface_arr[key]}</option>
                              ))
                          }
                       </select>
                      </div>

                      <div style={styles.items} className="col-md-12">
                        <div style={styles.item_header} className="col-md-6">
                          Level
                        </div>
                       <select name="level" className="col-md-6" style={styles.item_body} value={this.state.court_details.level}
                         onChange={this.handleChange}>
                          { 
                             Object.keys(this.state.level_arr).map((key,index)=>(
                               <option key={key} value={key}>{this.state.level_arr[key]}</option>
                              ))
                          }
                       </select>
                      </div>

                    </div>
                }

                

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Price
                    </div>
                    <input style={styles.input} name="price"
                    onChange={this.handleChange} />
                  </div>

                
                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Reference Courts
                    </div>
                    <div style={styles.item_ref_court} className="col-md-6">
                        <Multiselect
                          id="3"  
                          placeholder="Reference Courts"
                          data={this.state.courts_arr}
                          value = {this.state.ref_courts}
                          textField='court'
                          onSelect={this.onSelect} 
                          onChange={this.onChange}
                          filter='contains' 
                         />
                    </div>      

                </div>
               
                <div style={{padding:'1%', marginLeft:'10px'}}>
                  <div style={styles.button_submit} className="col-md-12">
                     {/*<span className="button1" style={{marginRight:'5px'}} onClick={()=>{this.props.history.goBack();}}>Back</span>*/}
                    <input className="button1" type="submit" value="Submit" style={{background:'#115691',border:'none'}} onClick={this.handleSubmit}/>
                  </div>
                </div>
                  
              </form>
              </div>
            }
          </div>
        </div>

      );
    }
  }
  
  export default AddCourt;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addCourt/AddCourt.js